// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1IVcY","rootSuccess":"CompleteLink_rootSuccess__3FmuX","rootFailure":"CompleteLink_rootFailure__2He9u","isDisabled":"CompleteLink_isDisabled__me-9Q"};